import { render } from "./WorkHistory.vue?vue&type=template&id=0434b91b"
import script from "./WorkHistory.vue?vue&type=script&lang=js"
export * from "./WorkHistory.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__